/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Overview_Finals_ManageInputs */



/**
* | output |
* | --- |
* | "Finals in progress. Manage scoring in the Finals tab." |
*
* @param {Overview_Finals_ManageInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const overview_finals_manage = /** @type {((inputs?: Overview_Finals_ManageInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Overview_Finals_ManageInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Finale en cours. Gérez le score dans l'onglet Finale.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Finales en progreso. Gestione las puntuaciones en la pestaña Finales.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Finais em andamento. Gerencie a pontuação na aba Finais.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Finali in corso. Gestisci i punteggi nella scheda Finali.")
	return /** @type {LocalizedString} */ ("Finals in progress. Manage scoring in the Finals tab.")
});